/** @jsx jsx */ import { css, jsx } from '@emotion/core'
import * as React from 'react'
import { Buttons, Slider, Time, TrackDetails, Wrapper } from '.'
import { ClickProp, DisabledOrHidden } from './Buttons'
import { StylesObj } from '../Styles/index'

const LazyWebform = React.lazy(() => import('./Waveform'))

const Player: React.FC<PlayerProps> = ({
  children,
  img,
  alt,
  artist,
  name,
  onClickPrev,
  onClickNext,
  buttonTimeout,
  accentColor = '#ff4d6a',
  cursorColor = 'rgba(255,77,106,.5)',
  wavesurferOptions,
  disabled = false,
  hidden = false,
  styles,
  waveform = false,
}) => {
  return (
    <Wrapper accentColor={accentColor} styles={styles}>
      <TrackDetails
        img={img}
        alt={alt}
        artist={artist}
        name={name}
        styles={styles}
      />
      <Buttons
        onClickPrev={onClickPrev}
        onClickNext={onClickNext}
        disabled={disabled}
        hidden={hidden}
        timeout={buttonTimeout}
        styles={styles}
      />
      {waveform ? (
        <React.Suspense fallback={<Slider styles={styles} />}>
          <LazyWebform
            trackInfo={`${artist}${name}`}
            progressColor={accentColor}
            cursorColor={cursorColor}
            wavesurferOptions={wavesurferOptions}
            styles={styles}
          />
        </React.Suspense>
      ) : (
        <Slider styles={styles} />
      )}
      <Time styles={styles} />
      <div
        css={css`
          grid-area: xtr;
        `}
      >
        {children}
      </div>
    </Wrapper>
  )
}

export default Player

type PlayerProps = {
  onClickNext?: ClickProp
  onClickPrev?: ClickProp
  className?: string
  style?: React.StyleHTMLAttributes<any>
  accentColor?: string
  cursorColor?: string
  wavesurferOptions?: object
  disabled?: DisabledOrHidden
  hidden?: DisabledOrHidden
  buttonTimeout?: number
  img?: string
  alt?: string
  artist?: string | React.ReactNode
  name?: string | React.ReactNode
  styles?: StylesObj
  waveform?: boolean
}
